const InternalChatLayout = () => import('./InternalChatLayout.vue');
const MessageThread = () => import('./MessageThread.vue');

export const routes = [
  {
    path: 'internal-chat',
    name: 'internal_chat',
    component: InternalChatLayout,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    children: [
      {
        path: ':conversationId',
        name: 'internal_chat_conversation',
        component: MessageThread,
        props: true,
      },
    ],
  },
];
